import React, { FunctionComponent } from 'react';

import { CreditCardPaymentStep as CommonCreditCard } from 'scenes/common/components/Steps';
import { LandlordFullPageProps } from 'scenes/landlord/types';

const CreditCardPaymentStep: FunctionComponent<LandlordFullPageProps> = ({
  onCreditCardPayment,
}) => <CommonCreditCard onCreditCardPayment={onCreditCardPayment} />;

export default CreditCardPaymentStep;
